import React, {ReactNode, useEffect, useRef, useState} from "react";
import Page from "../../components/page/Page";
import "./docs.css";
import {CouponsSection} from "./sections/CouponsSection";
import {TemplatesSection} from "./sections/TemplatesSection";
import {ConversationsSection} from "./sections/ConversationsSection";
import {MessagingLimitSection} from "./sections/MessagingLimitSection";
import {DeletePhoneNumberFromMBS} from "./sections/DeletePhoneNumberFromMBS";
import {ConnectToWhatsappTroubleshooting} from "./sections/connectToWhatsappTroubleshooting";
import {useNavigate} from "react-router-dom";

const SECTIONS = [
    { id: 'connect-to-whatsapp-troubleshooting', title: 'Whatsapp Connection Troubleshooting', section: ConnectToWhatsappTroubleshooting },
    { id: 'remove-phone-number-from-meta-business-suite', title: 'Remove Phone Number', section: DeletePhoneNumberFromMBS },
    { id: 'templates', section: TemplatesSection },
    { id: 'coupons', section: CouponsSection },
    { id: 'messagingLimit', title: 'Messaging Limit', section: MessagingLimitSection },
    { id: 'conversations', section: ConversationsSection }
]


const Docs = () => {
    const floatingListRef = useRef<HTMLDivElement | null>(null);
    const [isFloatingListSticky, setIsFloatingListSticky] = useState(false);
    const navigate = useNavigate();

    const onScroll = () => {
        if(window?.scrollY >= 120) {
            setIsFloatingListSticky(true);
        } else {
            setIsFloatingListSticky(false);
        }
        // const rect = floatingListRef.current?.getBoundingClientRect();
        // const top = rect?.top || 0;
        // if(top <= 0 && !isFloatingListSticky) {
        //     setIsFloatingListSticky(true);
        // } else if(isFloatingListSticky) {
        //     setIsFloatingListSticky(false);
        // }
    }

    useEffect(() => {
        window.addEventListener("scroll", onScroll);

        const hash = window.location.hash;
        if (hash) {
            const el = document.querySelector(hash);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth' }); // or 'auto'
            }
        }

        return () => {
            window.removeEventListener("scroll", onScroll);
        }
    }, []);

    const scrollTo = (sectionId: string) => (event: React.MouseEvent) => {
        event.stopPropagation();
        const element = document.getElementById(sectionId);
        if(element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    return <Page
        className="messages-page-container"
        title="Documentation"
    >
        <div id="docs-container" className="docs-container">
            <div className="sections-titles-list">
                <div ref={floatingListRef} className={`floating-list ${isFloatingListSticky ? 'floating' : ''}`}>
                    {SECTIONS.map(section => <a key={`section-title-${section.id}`} onClick={scrollTo(section.id)}>{section.title || section.id}</a>)}
                </div>
            </div>
            <div className="sections">
                <div className="description">
                    <div>This documentation is still WIP, if you have any further questions, don't hesitate contacting us.</div>
                </div>
                {SECTIONS.map(section => (
                    <div key={`section-${section.id}`} className="section" id={section.id}>
                        <div className="title">{section.title || section.id}</div>
                        <section.section id={section.id} scrollTo={scrollTo} />
                    </div>
                ))}
            </div>
        </div>
    </Page>
}

export default Docs;